import qs from 'qs'
import axios from 'axios'

export const groupService = ({
  listGroups (token) {
    return axios.get('/api/groups', {headers: {'Authorization': 'Bearer ' + token}})
  },
  getSingleGroup (token, groupId) {
    return axios.get('/api/group?groupId=' + groupId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  createGroup (token, formDataObj) {
    return axios.post('/api/group/create', formDataObj, {headers: {'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'}})
  },
  updateGroup (token, formDataObj) {
    return axios.put('/api/group/update', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  addCertificate (token, formDataObj) {
    return axios.post('/api/GroupCertificate/Create', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateCertificate (token, formDataObj) {
    return axios.put('/api/GroupCertificate/Update', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  deleteGroup (token, groupId) {
    return axios.delete('/api/group/delete?groupId=' + groupId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getCourseList (token, groupId) {
    return axios.get('/api/GroupCourses?groupId=' + groupId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getAttachedCertificateList (token, groupId) {
    return axios.get('/api/GroupCertificate/ListCertificatesByGroup?groupId=' + groupId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  associateGroupCourseMaster (token, formDataObj) {
    return axios.post('/api/GroupCourse/Create', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getEnrolledUsersOfGroup (token, groupId) {
    return axios.get('/api/Group/EnrolledUsers?groupId=' + groupId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  deleteAllProgressBuckets (token, groupId) {
    return axios.delete('/api/Group/DeleteAllProgressBuckets?groupId=' + groupId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getProgressBuckets (token, groupId) {
    return axios.get('/api/Group/ProgressBuckets?groupId=' + groupId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateGroupCourse (token, formDataObj) {
    return axios.put('/api/groupcourse/Update', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  deleteGroupCourseCertificate (token, gcmId) {
    return axios.delete('/api/GroupCourse/DeleteCertificate?gcmId=' + gcmId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  deleteGroupCertificate (token, certificateId) {
    return axios.delete('/api/GroupCertificate/Delete?certificateId=' + certificateId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  associateGroupWithLeapsMeditation (token, objToPass) {
    return axios.post('/api/leaps/availablegroupmeditations', objToPass, {headers: {'Authorization': 'Bearer ' + token}})
  },
  associateGroupWithMSNotificationTemplate (token, objToPass) {
    var stringifiedObj = qs.stringify(objToPass)
    return axios.post('/api/MSNotificationTemplate/Create', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateAssociatedGroupWithMSNotificationTemplate (token, objToPass) {
    var stringifiedObj = qs.stringify(objToPass)
    return axios.put('/api/MSNotificationTemplate/Update', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getAssociatedMSNotificationList (token, groupId) {
    return axios.get('/api/MSNotificationTemplate/GetAll?groupId=' + groupId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  deleteAssociatedMSNotificationTemplate (token, msNotificationTemplateAssociationId) {
    return axios.delete('/api/MSNotificationTemplate/Delete?MSNotificationTemplateAssociationId=' + msNotificationTemplateAssociationId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  associateGroupWithLeapsReflection (token, objToPass) {
    return axios.post('/api/MeetingMentorReflection', objToPass, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getAvailableMeditations (token) {
    return axios.get('/api/leaps/availablegroupmeditations', {headers: {'Authorization': 'Bearer ' + token}})
  },
  deleteAssociatedLeapsMeditationFromGroup (token, availableGroupMeditationId) {
    return axios.delete('/api/leaps/availablegroupmeditations?AvailableGroupMeditationsId=' + availableGroupMeditationId, {headers: {'Authorization': 'Bearer ' + token}})
  }
})



// WEBPACK FOOTER //
// ./src/server-util/group-service.js